<template>
  <div>
    <Field
      :label="$t('preset')"
      :options="presetOptions"
      required
      type="select"
      :value.sync="preset" />
    <Field
      :disabled="preset === null"
      :label="$t('blueprints')"
      required
      type="textarea"
      :value="blueprintsJson"
      @update:value="setBlueprints" />
    <Notice v-if="error" class="error">
      {{ error.message }}
    </Notice>
  </div>
</template>

<script>
import { assoc, evolve, identity, map, pipe, pluck, propEq, reject, sortBy, take } from 'rambda'
import { convertPasteToJson, isPastedSpreadsheet } from '@store/modules/articleBlueprint'
import { mergeLabelArrays } from '@utils/collections'

export default {
  props: {
    value: Array,
  },
  data() {
    const required = count => (sections) => {
      // TODO: do not use name
      const shouldApproveAlways = propEq('name', 'Introduction')

      const key = 'name'
      const required = pipe(
        reject(shouldApproveAlways),
        sortBy(Math.random),
        take(count),
        pluck(key),
      )(sections)

      return sections
        .map((section) => {
          const shouldApprove =
            shouldApproveAlways(section) ||
            required.includes(section[key])

          return {
            ...section,
            doCreateVariant: section.doCreateVariant && !shouldApprove,
            shouldApprove,
          }
        })
    }

    return {
      blueprintsJson: '',
      error: null,
      preset: null,
      presetOptions: mergeLabelArrays([
        {
          transform: identity,
          value: 0,
        },
        {
          transform: assoc('doPost', true),
          value: 1,
        },
        {
          transform: evolve({
            sections: map(assoc('shouldApprove', true)),
          }),
          value: 2,
        },
        {
          transform: evolve({
            sections: required(1),
          }),
          value: 3,
        },
        {
          transform: evolve({
            sections: required(2),
          }),
          value: 4,
        },
        {
          transform: evolve({
            sections: required(3),
          }),
          value: 5,
        },
      ], this.$t('presets')),
    }
  },
  computed: {
    presetActive() {
      return this.presetOptions
        .find(propEq('value', this.preset))
    },
  },
  methods: {
    setBlueprints(blueprintsJson) {
      try {
        if (isPastedSpreadsheet(blueprintsJson)) {
          const { transform } = this.presetActive

          blueprintsJson = pipe(
            convertPasteToJson,
            map(transform),
            JSON.stringify,
          )(blueprintsJson)
        }

        this.blueprintsJson = blueprintsJson

        const blueprints = JSON.parse(blueprintsJson)

        if (!Array.isArray(blueprints)) {
          throw new TypeError('Expected blueprints to be an array')
        }

        this.$up('value', blueprints)
        this.error = null
      } catch (error) {
        this.error = error
      }
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "blueprints": "Blueprints",
    "preset": "Preset",
    "presets": [
      "No required",
      "No required & auto-post",
      "All required",
      "1 required (random)",
      "2 required (random)",
      "3 required (random)"
    ]
  }
}
</i18n>
